import Checkboxes from '@storeblocks/checkboxes';
import { useField, useFormikContext } from 'formik';
import { type FC } from 'react';

import { useOrganizationName } from '@/api/organizations/hooks/useOrganizationName';
import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { useTexts } from '@/hooks/useTexts';
import { fmsWithTemplate } from '@/i18n/fmsWithTemplate';
import { nameof } from '@/util/nameof';
import { prettifyOrganizationName } from '@/util/prettifyOrganizationName';

import { FormValues } from '../types/FormValues';

export const ConfirmAuthorizedToSign: FC = () => {
  const texts = useTexts();

  const [field, meta] = useField<boolean>(nameof<FormValues>('confirmed'));

  const { setFieldValue } = useFormikContext<FormValues>();

  const organizationCmId = useOrganizationCmId();
  const { organizationName } = useOrganizationName(organizationCmId);
  return (
    <Checkboxes
      {...field}
      groupName="confirm-authorized-to-sign"
      data-test="confirm-authorized-to-sign"
      onChange={(e) => {
        setFieldValue(nameof<FormValues>('confirmed'), e.target.checked);
      }}
      options={[
        {
          id: 'CONFIRM',
          value: 'CONFIRM',
          label: fmsWithTemplate(
            texts.orders.signatureRight.confirmSignatureRight.title,
            {
              organization: prettifyOrganizationName(organizationName),
            },
          ),
        },
      ]}
      alertMessageType={meta.touched && meta.error ? 'error' : undefined}
      alertMessage={meta.error}
    />
  );
};
